import { FC, useEffect, useMemo } from 'react';

import { useStore } from '@project/components/hooks';
import { Button, Dropdown, Empty, Menu, Table, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import { PageModal } from '../../PageModal';

import { DownloadOutlined } from '@ant-design/icons';
import './style.scss';

const { Title } = Typography;

export const CartogramsPageModal: FC = observer(function CartogramsPageModal() {
  const {
    cartogramsPageModal: {
      pageModalController,
      cartogramTable,
      ...cartogramsPageModal
    },
  } = useStore();

  const { tableData, tableColumnsData, cartogram } = cartogramTable;

  useEffect(() => {
    cartogramsPageModal.bind();

    return () => cartogramsPageModal.unbind();
  }, []);

  const content = useMemo(() => {
    if (!tableData || !tableColumnsData) {
      return <Empty />;
    }

    return (
      <div className="cartograms-page-modal">
        <Dropdown
          popupRender={() => (
            <Menu>
              <Menu.Item key="xlsx" onClick={cartogramTable.exportAsXlsx}>
                xlsx-файл
              </Menu.Item>
              <Menu.Item key="csv" onClick={cartogramTable.exportAsCsv}>
                csv-файл
              </Menu.Item>
            </Menu>
          )}
        >
          <Button
            className="cartograms-page-modal__export"
            icon={<DownloadOutlined />}
          />
        </Dropdown>

        <Table
          rowKey="cartogram"
          className="cartogram-table"
          dataSource={tableData}
          columns={tableColumnsData}
          pagination={false}
        />
      </div>
    );
  }, [tableData, tableColumnsData, cartogram]);

  return (
    <PageModal
      isOpen={pageModalController.isActive}
      onClose={pageModalController.close}
      title={<Title level={3}>Картограмма</Title>}
    >
      {content}
    </PageModal>
  );
});
